import { pagesActions } from "../store/pages-slice";
import { uiActions } from "../store/ui-slice";

export const fetchPagesSections = (apiSlug, pageSlug) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/${apiSlug}/${pageSlug}`
      );

      if (!response.ok) {
        const errorData = await response.json();
        const errorMessage = errorData.data
          ? errorData.data[0]
          : errorData.message;
        throw new Error(errorMessage);
      }

      const data = await response.json();

      return data[0] || {};
    };

    try {
      const postData = await fetchData();
      postData.endpoint = pageSlug;
      postData.apiSlug = apiSlug;
      dispatch(pagesActions.setPageSections(postData));
    } catch (error) {
      let errorMessage = "An error occurred while fetching pages sections";

      if (error instanceof Error) {
        errorMessage = error.message;
      }
      dispatch(pagesActions.setLoadingData(false));
      dispatch(
        uiActions.showNotification({
          status: "danger",
          title: "Error!",
          message: errorMessage,
        })
      );
    }
  };
};

export const fetchBlogPosts = (page = 1, category = "") => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/blogs/posts?paged=${page}&category=${category}`
      );

      if (!response.ok) {
        const errorData = await response.json();
        const errorMessage = errorData.data
          ? errorData.data[0]
          : errorData.message;
        throw new Error(errorMessage);
      }

      const data = await response.json();

      return data || {};
    };

    try {
      const postData = await fetchData();
      dispatch(pagesActions.setArchiveBlogPosts(postData));
    } catch (error) {
      let errorMessage = "An error occurred while fetching pages sections";

      if (error instanceof Error) {
        errorMessage = error.message;
      }
      dispatch(pagesActions.setLoadingData(false));
      dispatch(
        uiActions.showNotification({
          status: "danger",
          title: "Error!",
          message: errorMessage,
        })
      );
    }
  };
};

export const sendJobApplicationEmail = (
  fullName,
  email,
  message,
  jobId,
  nonce
) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/submissions/job-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            name: fullName,
            email,
            description: message,
            job_id: jobId,
            nonce,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        const errorMessage = errorData.data
          ? errorData.data[0]
          : errorData.message || "Something went wrong!";
        throw new Error(errorMessage);
      }

      const data = await response.json();
      return data || {};
    };

    try {
      const result = await fetchData();

      return result;
    } catch (error) {
      let errorMessage =
        "An error occurred while sending the job application email.";

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      dispatch(
        uiActions.showNotification({
          status: "danger",
          title: "Error!",
          message: errorMessage,
        })
      );

      throw error;
    }
  };
};

export const sendContactformAplication = (form_data) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/submissions/contact-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            form_data,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        const errorMessage = errorData.data
          ? errorData.data[0]
          : errorData.message || "Something went wrong!";
        throw new Error(errorMessage);
      }

      const data = await response.json();
      return data || {};
    };

    try {
      const result = await fetchData();

      return result;
    } catch (error) {
      let errorMessage =
        "An error occurred while sending the job application email.";

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      dispatch(
        uiActions.showNotification({
          status: "danger",
          title: "Error!",
          message: errorMessage,
        })
      );

      throw error;
    }
  };
};
